import { store } from "../lib/store.js";
import { dismissToast } from "../lib/toasts.js";

const SEVERITY_LABEL = { success: "Sucesso", info: "Info", warning: "Aviso", error: "Erro" };

export function mountToastTray(root) {
  root.innerHTML = `<div class="toast-tray" role="region" aria-label="Notificações" aria-live="polite"></div>`;
  const tray = root.querySelector(".toast-tray");

  const unsubscribe = store.toasts.subscribe((toasts) => {
    tray.innerHTML = toasts
      .map(
        (toast) => `
        <div class="toast toast--${toast.severity}" data-toast-id="${toast.id}">
          <span class="toast-label">${SEVERITY_LABEL[toast.severity] ?? "Info"}</span>
          <span class="toast-message">${escapeHtml(toast.message)}</span>
          <button class="toast-close" aria-label="Fechar notificação" data-toast-id="${toast.id}">×</button>
        </div>
      `,
      )
      .join("");
  });

  tray.addEventListener("click", (event) => {
    const button = event.target.closest(".toast-close");
    if (!button) return;
    dismissToast(Number(button.dataset.toastId));
  });

  return () => {
    unsubscribe();
    root.innerHTML = "";
  };
}

function escapeHtml(text) {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}
